module.exports = __webpack_public_path__ + "img/9.Heavy20ktGoldNecklace.d6df240d.png";